import React, {forwardRef} from 'react';
import classNames from 'classnames';

const TextArea = forwardRef(function _InputField(props, ref) {
  const {className, resize, error, ...restProps} = props;
  return (
    <>
      <textarea
        ref={ref}
        className={classNames('py-3 px-4 border rounded-sm', className, {
          'resize-none': resize,
          'border-error': error,
          'border-gray-400': !error,
        })}
        {...restProps}
      />
      {error && <div className="text-error text-sm pt-1">{error}</div>}
    </>
  );
});

export default TextArea;
